import React, { FC } from 'react';
import { Info } from '@assets/svg/icons';
import { useTranslation } from 'react-i18next';

const AttachmentsSidebar: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h2>{t('sidebar.docs.h2')}</h2>
      <p>{t('sidebar.docs.paragraph')}</p>
      <dl>
        <a target="_blank">
          <dt>{t('sidebar.docs.dt1')}</dt>
        </a>
        <dd>
          <Info className='icon-info' />
          {t('sidebar.docs.dd1')}
        </dd>
        <a target="_blank">
          <dt>{t('sidebar.docs.dt2')}</dt>
        </a>
        <dd>
          <Info className='icon-info' />
          {t('sidebar.docs.dd2')}
        </dd>
        <dt>{t('sidebar.docs.dt3')}</dt>
        <dd>
          <Info className='icon-info' />
          {t('sidebar.docs.dd3')}
        </dd>
      </dl>
    </>
  );
};

export default AttachmentsSidebar;
